import { Pipe, PipeTransform, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@Pipe({
    name: 'euiTruncate',
})
export class EuiTruncatePipe implements PipeTransform {
    transform(value: string, limit: number = 40, trail: String = '\u2026'): string {
        if (value) {
            if (limit < 0) {
                limit *= -1;
                return value.length > limit ? trail + value.substring(value.length - limit, value.length) : value;
            } else {
                return value.length > limit ? value.substring(0, limit) + trail : value;
            }
        }
        return;
    }
}

@NgModule({
    imports: [CommonModule],
    exports: [EuiTruncatePipe],
    declarations: [EuiTruncatePipe],
})
export class EuiTruncatePipeModule { }
